module.exports = __webpack_public_path__ + "mt.93f3f23ed8f38bb1b9e0.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/mt.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/mt.svg
// module chunks = styles